<template>
  <element>
    <AppBar :title="$t('carDetailsPage.title')" />
    <v-container>
      <h3 class="category-label">{{ $t('carDetailsPage.infoTable.title') }}</h3>
      <div class="d-block d-flex flex-row-reverse mb-2">
        <v-btn class="btn-sm p-2" :width="45" :height="40" color="#d9753b" :fab="true" @click="startPartsExtractionProcess()" dark>
          <v-icon>mdi-car-door</v-icon>
        </v-btn>
      </div>

      <CarDetailInfoTable :info="car" />
      <ImageGallery class="mt-3" :images="images" />
      <h3 class="category-label">{{ $t('carDetailsPage.partTable.title')}}</h3>
      <treeselect
        v-model="selectedPartGroup"
        :multiple="false"
        :open-on-click="true"
        :options="partGroupOptions"
        :placeholder="null"
      ></treeselect>
      <PartTable 
        class="mb-4" 
        :headers="$t('carDetailsPage.partTable.headers')" 
        :parts="parts" 
        :displayItems="displayItems"
        @rowClick="onTableClick" />
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue";
import CarDetailInfoTable from "@/components/cardetail/CarDetailInfoTable.vue";
import PartTable from "@/components/common/PartTable.vue";
import ImageGallery from "@/components/common/ImageGallery.vue"

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import { DOCUMENT_TYPE_CAR_PICTURE } from "@/constants"
import { DOCUMENT_TYPE_CAR_REGDOC } from "@/constants"

import { getTreeItems } from "@/helpers"

export default {
  name: "CarDetailsPage",
  props: {

  },
  components: {
    AppBar,
    CarDetailInfoTable,
    PartTable,
    ImageGallery,
    Treeselect,
  },
  data() {
    return {
      car: null,
      parts: [],
      images: [],
      partGroups: [],
      selectedPartGroup: null,
      partGroupOptions: null,
      documentTypes: [DOCUMENT_TYPE_CAR_PICTURE, DOCUMENT_TYPE_CAR_REGDOC],
      displayItems: ['name', 'serial_number']
    }
  },
  // computed: {
  //   partGroupOptions: function () {
  //     return getItems(this.partGroups)
  //   }
  // },
  watch: {
    selectedPartGroup: function (value) {
      if (value === undefined) {
        this.parts = []
        return
      }

      const url = `/Parts/get?part_group_id[]=${value}`

      this.axios.get(url, {}, { withCredentials: true })
      .then(response => {
        this.parts = response.data.data[0].parts
      })
      .catch(error => {
        console.log("Failed retrieving parts.", error)
      })
    }
  },
  methods: {
    onTableClick(part_id) {
      /* td 202009070314 updated this method to take a partId directly as argument (due to #113) */
      this.$router.push({name: 'part', params: { id: part_id }})
    },
    startPartsExtractionProcess(carId=this.$route.params.id) {
      /* td 202009032320 #105 added starting processes by hardcoded name and variables */
      let variables={variables:{car_id:{value: carId,type: "Integer"}}}
      console.log ('startPartsExtractionProcess', variables);
      this.$store.dispatch('startBPMProcess', ['PartsExtraction', variables]) /* #105 add parameters to the method*/
      .then(response => {
        console.log("New process instance ID:", response)
      })
      .catch(error => {
        console.log("Cannot start new process:", error)
        this.$store.dispatch('showNotification', {
          text: 'errorWhileStartingProcess',
          interval: 4000})
      })
    }
  },
  created() {
    const id = this.$route.params.id

    this.$store.dispatch('retrieveCars', { id })
    .then(response => {
      this.car = response
    })
    .catch(error => {
      this.car = null
      console.log("Failed retrieving car info", error)
    })

    this.images = []

    this.documentTypes.forEach( type => {
      const url = `/Documents/get?document_type_id=${type}&data_id=${id}`
      this.axios.get(url, {}, { withCredentials: true })
      .then(response => {
        this.images = this.images.concat(response.data.data.map( e => { return e.data_doc_raw }))
      })
      .catch(error => {
        console.log("Failed retrieving car pictures.", error)
      })
    })

    const url = `/PartGroups/get?car_id=${id}`
    this.axios.get(url, {}, { withCredentials: true })
    .then(response => {
      this.partGroups = response.data.data
      console.log("PartGroups", JSON.stringify(this.partGroups))
      this.partGroupOptions = getTreeItems(this.partGroups)
      console.log("PartGroupOptions", JSON.stringify(this.partGroupOptions))
    })
    .catch(error => {
      console.log("Failed retrieving part groups.", error)
    })
  },
}
</script>

<style>

</style>
